import { orderXClient } from '@/service/client'
import {
  CreateWatchlistRequest,
  DeleteWatchlistRequest,
  GetWatchlistsResponse,
  RenameWatchlistRequest,
  ReorderWatchlistsRequest,
  SetWatchlistRequest,
  Watchlist,
  WatchlistMutationResponse,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function getWatchlists(): Promise<GetWatchlistsResponse> {
  try {
    const { data } = await orderXClient.post<{ getWatchlistsResponse?: GetWatchlistsResponse }>(
      '/api',
      { getWatchlists: {} }
    )
    return data.getWatchlistsResponse ?? { watchlists: [] }
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function createWatchlist(payload: CreateWatchlistRequest): Promise<Watchlist> {
  try {
    const { data } = await orderXClient.post<{
      watchlistMutationResponse?: WatchlistMutationResponse
    }>('/api', { createWatchlist: payload })
    const watchlist = data.watchlistMutationResponse?.watchlist
    if (!watchlist) return Promise.reject({ status: 400, message: 'Failed to create watchlist' })
    return watchlist
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function setWatchlist(payload: SetWatchlistRequest): Promise<Watchlist> {
  try {
    const { data } = await orderXClient.post<{
      watchlistMutationResponse?: WatchlistMutationResponse
    }>('/api', { setWatchlist: payload })
    const watchlist = data.watchlistMutationResponse?.watchlist
    if (!watchlist) return Promise.reject({ status: 400, message: 'Failed to set watchlist' })
    return watchlist
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function renameWatchlist(payload: RenameWatchlistRequest): Promise<Watchlist> {
  try {
    const { data } = await orderXClient.post<{
      watchlistMutationResponse?: WatchlistMutationResponse
    }>('/api', { renameWatchlist: payload })
    const watchlist = data.watchlistMutationResponse?.watchlist
    if (!watchlist) return Promise.reject({ status: 400, message: 'Failed to rename watchlist' })
    return watchlist
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function deleteWatchlist(payload: DeleteWatchlistRequest): Promise<void> {
  try {
    await orderXClient.post('/api', { deleteWatchlist: payload })
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function reorderWatchlists(
  payload: ReorderWatchlistsRequest
): Promise<GetWatchlistsResponse> {
  try {
    const { data } = await orderXClient.post<{ getWatchlistsResponse?: GetWatchlistsResponse }>(
      '/api',
      { reorderWatchlists: payload }
    )
    return data.getWatchlistsResponse ?? { watchlists: [] }
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
